import { render, staticRenderFns } from "./AgentPhoto.vue?vue&type=template&id=6c6a49c0&scoped=true"
import script from "./AgentPhoto.vue?vue&type=script&lang=js"
export * from "./AgentPhoto.vue?vue&type=script&lang=js"
import style0 from "./AgentPhoto.vue?vue&type=style&index=0&id=6c6a49c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6a49c0",
  null
  
)

export default component.exports